import { render } from "./ShapeStylePanel.vue?vue&type=template&id=998a7a02&scoped=true&ts=true"
import script from "./ShapeStylePanel.vue?vue&type=script&lang=ts"
export * from "./ShapeStylePanel.vue?vue&type=script&lang=ts"

import "./ShapeStylePanel.vue?vue&type=style&index=0&id=998a7a02&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998a7a02"]])

export default __exports__